////////////////////////////
//UPGRADES
////////////////////////////
export const FETCH_UPGRADES = 'FETCH_UPGRADES';
export const FETCH_UPGRADES_FAIL = 'FETCH_UPGRADES_FAIL';
export const FETCH_LOADING = 'FETCH_LOADING';
////////////////////////////
//ITINERARIES
////////////////////////////
export const FETCH_ITINERARIES = 'FETCH_ITINERARIES';
export const FETCH_ITINERARIES_FAIL = 'FETCH_ITINERARIES_FAIL';

////////////////////////////
//CAPACITY
////////////////////////////
export const FETCH_CAPACITY = 'FETCH_CAPACITY';
export const FETCH_LIVE_CAPACITY = 'FETCH_LIVE_CAPACITY';
export const FETCH_LIVE_CAPACITY_FAIL = 'FETCH_LIVE_CAPACITY_FAIL';
export const FETCH_CAPACITY_FAIL = 'FETCH_CAPACITY_FAIL';
////////////////////////////


////////////////////////////
//CURRENCY
////////////////////////////
export const FETCH_CURRENCY = 'FETCH_CURRENCY';
export const FETCH_CURRENCY_FAIL = 'FETCH_CURRENCY_FAIL';
////////////////////////////


////////////////////////////
//NATIONALITY
////////////////////////////
export const FETCH_NATIONALITY = 'FETCH_NATIONALITY';
export const FETCH_NATIONALITY_STATE = 'FETCH_NATIONALITY_STATE';
export const FETCH_NATIONALITY_FAIL = 'FETCH_NATIONALITY_FAIL';
////////////////////////////


////////////////////////////
//BOOKING
////////////////////////////
export const RESET_BOOKING = 'RESET_BOOKING';

export const BOOK_TOUR = "BOOK_TOUR";
export const BOOK_TOUR_FAIL = "BOOK_TOUR_FAIL";
export const FETCH_TOUR = "FETCH_TOUR";
export const FETCH_TOUR_FAIL = "FETCH_TOUR_FAIL";

export const SET_CURRENCY = "SET_CURRENCY";
export const SET_DEPARTURE = 'SET_DEPARTURE';
export const SET_TOURID = 'SET_TOURID';
export const SET_PROMO_CODE = 'SET_PROMO_CODE';
export const SET_CITYID = 'SET_CITYID';
export const SET_PASSENGER_TYPE = "SET_PASSENGER_TYPE";
export const SET_PASSENGER_DETAILS = "SET_PASSENGER_DETAILS";
export const SET_PROCESSING = "SET_PROCESSING";
export const SET_BOOKING = "SET_BOOKING";
export const SET_BOOKING_GROUP = "SET_BOOKING_GROUP";
export const SET_PRICES = "SET_PRICES";
export const SET_LOCKOUT = "SET_LOCKOUT";
// export const SET_AFFILIATE_APP_ID = "SET_AFFILIATE_APP_ID";
export const SET_TRIPS_PASSENGERS = "SET_TRIPS_PASSENGERS";
export const UPDATE_TOUR_INFORMATION_LOADING = "UPDATE_TOUR_INFORMATION_LOADING";
export const REMOVE_TOUR_LOADING = "REMOVE_TOUR_LOADING";
export const UPDATE_TOUR_INFORMATION_FAIL = "UPDATE_TOUR_INFORMATION_FAIL";
export const ADD_UPGRADES = "ADD_UPGRADES";
export const REMOVE_UPGRADES = "REMOVE_UPGRADES";
////////////////////////////


////////////////////////////
//PRODUCTS
////////////////////////////
export const SET_PRODUCT_REDIRECT = 'SET_PRODUCT_REDIRECT';
export const FETCH_PRODUCT = 'FETCH_PRODUCT'; //SINGLE PRODUCT
export const FETCH_PRODUCT_FAIL = 'FETCH_PRODUCT_FAIL'; //SINGLE PRODUCT FAIL
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS'; //ALL PRODUCTS
export const FETCH_PRODUCTS_FAIL = 'FETCH_PRODUCTS_FAIL'; //ALL PRODUCTs FAIL
////////////////////////////


////////////////////////////
//DISCOUNT
////////////////////////////
export const FETCH_DISCOUNT = "FETCH_DISCOUNT";
export const FETCH_DISCOUNT_FAIL = "FETCH_DISCOUNT_FAIL";
export const FETCH_DISCOUNT_VALID = "FETCH_DISCOUNT_VALID";
export const DISCOUNT_RESET = 'DISCOUNT_RESET';
////////////////////////////


////////////////////////////
//CONTENTFUL
////////////////////////////
export const SET_CONTENTFUL = "SET_CONTENTFUL";
////////////////////////////


////////////////////////////
//ERRORS MESSAGE
////////////////////////////
export const FETCH_ERROR_MESSAGE = 'FETCH_ERROR_MESSAGE';
export const FETCH_ERROR_MESSAGE_FAIL = 'FETCH_ERROR_MESSAGE_FAIL';
////////////////////////////


////////////////////////////
//UTILS
////////////////////////////
export const SET_FOOTER_MODAL = 'SET_FOOTER_MODAL';


////////////////////////////
//PASSENGER
////////////////////////////
export const UPDATE_LEAD_PAX_SUCCESS = "UPDATE_LEAD_PAX_SUCCESS";
export const UPDATE_LEAD_PAX_FAIL = "UPDATE_LEAD_PAX_FAIL";
export const UPDATE_PAX_SUCCESS = "UPDATE_PAX_SUCCESS";
export const UPDATE_PAX_FAIL = "UPDATE_PAX_FAIL";



// WEBPACK FOOTER //
// ./src/actions/types.js